/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const SEMANTIC_AUDITOR_TEST_LIST_DATA = [
  {
    dateCreated: '2024-12-17T10:00:00.000Z',
    id: 'f7c3bc1f-3a42-4c8e-b634-924b93bf489f',
    lastRun: '2024-12-17T10:30:00.000Z',
    name: 'Process 1',
    questions: 5,
    totalRuns: 10,
  },
  {
    dateCreated: '2024-12-17T10:10:00.000Z',
    id: 'd4b0d17e-60cd-4459-a6b3-6e0bb0fa6941',
    lastRun: '2024-12-17T10:40:00.000Z',
    name: 'Process 2',
    questions: 5,
    totalRuns: 27,
  },
  {
    dateCreated: '2024-12-17T10:20:00.000Z',
    id: 'a9c6bfa0-25d9-4b67-9a35-435577423f8b',
    lastRun: '2024-12-17T10:50:00.000Z',
    name: 'Process 3',
    questions: 5,
    totalRuns: 42,
  },
  {
    dateCreated: '2024-12-17T10:30:00.000Z',
    id: '28d5f650-f5a0-4677-9ab5-c28bda897295',
    lastRun: '2024-12-17T11:00:00.000Z',
    name: 'Process 4',
    questions: 5,
    totalRuns: 3,
  },
  {
    dateCreated: '2024-12-17T10:40:00.000Z',
    id: 'aa5cbddb-80f5-4753-bdb7-3b2c907df1fd',
    lastRun: '2024-12-17T11:10:00.000Z',
    name: 'Process 5',
    questions: 5,
    totalRuns: 58,
  },
  {
    dateCreated: '2024-12-17T10:50:00.000Z',
    id: '1e2b922c-756b-4b90-a013-eb0272580efd',
    lastRun: '2024-12-17T11:20:00.000Z',
    name: 'Process 6',
    questions: 5,
    totalRuns: 16,
  },
  {
    dateCreated: '2024-12-17T11:00:00.000Z',
    id: '915e6e1f-6918-47a9-b8f4-8716e0016294',
    lastRun: '2024-12-17T11:30:00.000Z',
    name: 'Process 7',
    questions: 5,
    totalRuns: 74,
  },
  {
    dateCreated: '2024-12-17T11:10:00.000Z',
    id: '7419d747-92d3-4666-9f0f-572cd3c71292',
    lastRun: '2024-12-17T11:40:00.000Z',
    name: 'Process 8',
    questions: 5,
    totalRuns: 6,
  },
  {
    dateCreated: '2024-12-17T11:20:00.000Z',
    id: '3142de47-b2cc-4235-84dd-f0f4d1a549ea',
    lastRun: '2024-12-17T11:50:00.000Z',
    name: 'Process 9',
    questions: 5,
    totalRuns: 89,
  },
  {
    dateCreated: '2024-12-17T11:30:00.000Z',
    id: 'edbd2be5-4f0d-4b5d-b7dc-3ba7824499c9',
    lastRun: '2024-12-17T12:00:00.000Z',
    name: 'Process 10',
    questions: 5,
    totalRuns: 20,
  },
];
